import {AnalyticsRepository} from "@api/repositories/AnalyticsRepository";
import {
    PartnerAnalyticsDataInterface
} from "@api/repositories/interfaces/PartnerAnalyticsDataInterface";
import {PartnerAnalyticsParametersInterface} from "@api/repositories/interfaces/PartnerAnalyticsParametersInterface";
import Partner from "@share/catalog/components/Partner.vue";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {downloadBlob} from "@common/BlobDownloadHelper";
import i18n from "@service/locale/i18";

export class AnalyticsHelper {
    isAnalyticsFetched = false;
    isFetchingAnalytics = false;
    analyticsData: PartnerAnalyticsDataInterface | undefined | null = null;
    private readonly repository: AnalyticsRepository | null = null;

    constructor(private readonly partnerComponent: Partner) {
        this.repository = partnerComponent.$repositories.get(RepositoryFabric.ANALYTICS);
    }

    private prepareAnalyticsParameter(): PartnerAnalyticsParametersInterface {
        return {
            backend: this.partnerComponent.$store.state.session.backend,
            sessionId: this.partnerComponent.$store.state.session.sessionId,
            eventId: this.partnerComponent.$store.getters['events/selectedEvent']?.id,
            exhibition: {
                id: (this.partnerComponent as any).itemId,
                schemaId: (this.partnerComponent as any).schemaId
            }
        };
    }

    async fetch() {
        this.isFetchingAnalytics = true;
        try {
            const parameters = this.prepareAnalyticsParameter();
            this.analyticsData = await this.repository?.partnerData(parameters);
            this.isAnalyticsFetched = true;
        }
        catch (e) {
            this.partnerComponent.$store.dispatch('reportError', e);
        }
        finally {
            this.isFetchingAnalytics = false;
        }
    }

    async getVisitorsReport() {
        this.isFetchingAnalytics = true;
        try {
            const parameters = this.prepareAnalyticsParameter();
            const response = await this.repository?.visitorsReport(parameters);
            if (response && response.data) {
                downloadBlob(response.data as Blob, `${parameters.sessionId}_${parameters.eventId}_report.xlsx`);
            }
        }
        catch (e){
            alert(i18n.t('exhibition.analytics file not formed'));
            this.partnerComponent.$store.dispatch('reportError', e);
        }
        finally {
            this.isFetchingAnalytics = false;
        }
    }
}
